module.exports = __webpack_public_path__ + "static/media/15.aec1c763.png";